import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SYSTEM_PILLARS, WORKFLOW } from '../data/content';
export function SystemIntro() {
  return <section className="bg-cream py-10 sm:py-12" aria-labelledby="system-title" data-id="element-164" data-mp="239wvscxpapwm">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-165" data-mp="288hxkgslphn6">
        <SectionHeading tone="light" eyebrow="Functional Coach System™" title="The System You’ve Been Waiting For" subtitle="One professional operating system built for real-world functional coaching." data-id="element-166" data-mp="28a2v8fa7pgp9" />

        <p className="mx-auto mt-5 max-w-2xl text-center text-[14px] leading-snug text-charcoal/80 sm:text-[15px]" data-id="element-167" data-mp="1khchc0ir0ncc">
          Instead of opening a blank page every time you plan a session,{' '}
          <strong className="font-semibold text-charcoal" data-id="element-168" data-mp="2vycbz2skje9j">
            Functional Coach System™
          </strong>{' '}
          brings everything you use to coach into one organized framework:
        </p>

        <ul className="mx-auto mt-5 grid max-w-2xl grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-169" data-mp="15hm5f8tymwpz">
          {SYSTEM_PILLARS.map(pillar => <li key={pillar} className="flex items-center gap-2" data-id="element-170" data-mp="11htpuc65fqb4">
              <CheckIcon className="h-4 w-4 shrink-0 text-gold-deep" aria-hidden="true" data-id="element-171" data-mp="wgwd4f3wroh0" />
              <span className="font-display text-[13.5px] font-semibold uppercase tracking-wide text-charcoal sm:text-[15px]" data-id="element-172" data-mp="rkyw06ktme36">
                {pillar}
              </span>
            </li>)}
        </ul>

        <div className="mt-7 rounded-xl bg-charcoal px-3 py-5 shadow-premium sm:px-6" data-id="element-173" data-mp="hr88p50fk9p2">
          <p className="text-center text-[9.5px] font-semibold uppercase tracking-[0.26em] text-gold" data-id="element-174" data-mp="dpdcgexcwmi5">
            The Coaching Workflow
          </p>
          <ol className="mt-3.5 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-2" data-id="element-175" data-mp="3tjrq89hhmpa">
            {WORKFLOW.map((step, index) => <li key={step} className="flex items-center gap-1.5" data-id="element-176" data-mp="3v1o3bus89rtw" data-mpi={index}>
                <span className="rounded-md border border-gold/25 bg-gold/[0.07] px-2.5 py-1.5 font-display text-[12px] font-bold uppercase tracking-[0.1em] text-cream sm:px-3.5 sm:text-[15px]" data-id="element-177" data-mp="3lb7h10sm4xs1">
                  {step}
                </span>
                {index < WORKFLOW.length - 1 ? <ArrowRightIcon className="h-3 w-3 shrink-0 text-gold/50 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-178" data-mp="3gdxh2r7ll3py" /> : null}
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}